import { IClient } from 'src/app/store/client/reducers/client.reducers';
import { ClientEntity } from './../../models/clients';
import {IPortfolio} from "../../models/portfolios";

//Entities within selectedEntities do not respond to changes to the date in the entityDateSelector - this is fine in most cases as the values
//are not affected by date (i.e. entityId and name), however it does cause an issue with the NAV. NAV's of selected entities should not be used
//if possible
export interface IGeneralSelectionState {
    toDate: Date;
    fromDate?: Date;
    selectedEntities: ClientEntity[];
    selectedPortfolios: IPortfolio[];
    baseUrl: string;
    dataInitalised: boolean;
    selectedCurrency: string | number;
    clientTitle: string;
    selectedClient: IClient;
}

export const initialGeneralSelectionState = {
    toDate: new Date(),
    fromDate: new Date(0),
    selectedEntities: [],
    selectedPortfolios: [],
    baseUrl: '',
    dataInitalised: false,
    selectedCurrency: null,
    clientTitle: '',
    selectedClient: null
};
